import type { SVGProps } from 'react'

interface CO2IconProps extends SVGProps<SVGSVGElement> {}

export function CO2Icon(props: CO2IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M441.54-366.15q-14.69 0-25.04-10.35t-10.35-25.04v-156.92q0-14.69 10.35-25.04t25.04-10.35h116.92q14.69 0 25.04 10.35t10.35 25.04v156.92q0 14.69-10.35 25.04t-25.04 10.35H441.54Zm12.31-47.7h92.3v-132.3h-92.3v132.3ZM686.15-270v-72.31q0-14.69 10.35-25.04 10.35-10.34 25.04-10.34h84.61v-48.46h-96.77q-9.69 0-16.46-6.77-6.77-6.77-6.77-17.08 0-9.69 6.77-16.77t17.08-7.08h108.46q14.69 0 25.04 10.35t10.35 25.04v60.77q0 14.69-10.35 25.04-10.35 10.34-25.04 10.34h-84.61v48.46H830q9.69 0 16.77 7.08t7.08 16.77q0 10.31-7.08 17.08-7.08 6.77-16.77 6.77H710q-10.31 0-17.08-6.77-6.77-6.77-6.77-17.08Zm-524.61-96.15q-14.69 0-25.04-10.35t-10.35-25.04v-156.92q0-14.69 10.35-25.04t25.04-10.35h116.92q14.69 0 25.04 10.35t10.35 25.04v27.15q0 9.31-7.08 16.08-7.08 6.77-16.77 6.77-10.31 0-17.08-6.77-6.77-6.77-6.77-17.08v-13.84h-92.3v132.3h92.3v-13.84q0-9.7 6.77-16.77 6.77-7.08 17.08-7.08 9.69 0 16.77 7.08 7.08 7.07 7.08 16.77v26.15q0 14.69-10.35 25.04t-25.04 10.35H161.54Z" />
    </svg>
  )
}
